import { numberMoney } from 'Data/format.js'
import { TRANSACTION_DTYPE } from 'Data/payments.js'

export function getAmount(entry) {
  return numberMoney(
    Math.abs(
      entry.transactions.reduce(
        (acc, transaction) => acc + transaction.amount,
        0
      )
    )
  )
}

export function getDescription(entry) {
  return entry.transactions
    .map(
      transaction =>
        `${getAdjustmentName(transaction)} (${numberMoney(Math.abs(transaction.amount))})`
    )
    .join(' + ')
}

function getAdjustmentName(transaction) {
  switch (transaction.dtype) {
    case TRANSACTION_DTYPE.WriteOff:
      return 'Write off'
    case TRANSACTION_DTYPE.DiscountAdjustment:
      return `${transaction.discount_adjustment.discount.name || 'Discount'}${transaction.discount_adjustment.discount_reverse_adjustments.length > 0 ? ' - Reversed' : ''}`
    case TRANSACTION_DTYPE.Refund:
      return 'Refund'
    case TRANSACTION_DTYPE.FixAdjustment:
      return 'Fix Adjustment'
    case TRANSACTION_DTYPE.MigrationFixAdjustment:
      return 'Migration Fix Adjustment'
    default:
      return transaction.dtype
  }
}
